<template>
    <div class="win">
        <div class="header">
            <div class="navItem">
                <i class="iconfont icon-nenghao" style="font-size: 28px"></i>
                <div class="title" v-bind:style="{ letterSpacing: language === 'en' ? '0px':''}">{{ $t('ems.energy.title') }}</div>
                <div class="desc">{{ $t('ems.energy.desc') }}</div>
            </div>
            <div class="navRight">
<!--                <div class="creatTime">{{ $t('ems.energy.DataUpdateTime') }}<span>2021/10/21 22:49:57</span></div>-->
                <template v-if="true">
                    <div class="btn" style="width: 110px"  @click="fresh"><i class="iconfont icon-banbengengxin"></i>{{ $t('ems.energy.UpdateTheData') }}</div>
                </template>
            </div>
        </div>
        <div class="content" v-loading="loading"  element-loading-text="Loading"  element-loading-spinner="el-icon-loading"  element-loading-background="rgba(42, 43, 44, 0.6)">
            <div class="pcs_tab">
                <div :class="{tab_item: true,  active: active === 0}" @click="tabChange(0)" v-if="systemMenu.SD">
                    <div class="tab_item_top"><i class="iconfont icon-zu"></i>
                    <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.energy.grid')" placement="top-start">
                        <span>{{ $t('ems.energy.grid') }}</span>
                    </el-tooltip>
                    </div> 
                    <div class="arrow"></div>
                </div>
                <div :class="{tab_item: true,  active: active === 1}"  @click="tabChange(1)" v-if="systemMenu.GF">
                    <div class="tab_item_top"><i class="iconfont icon-taiyangnengdianchi"></i>
                    <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.energy.Photovoltaic')" placement="top-start">
                        <span>{{ $t('ems.energy.Photovoltaic') }}</span>
                    </el-tooltip>
                    </div>
                    <div class="arrow"></div>
                </div>
                <div :class="{tab_item: true,  active: active === 2}"  @click="tabChange(2)" v-if="systemMenu.CN">
                    <div class="tab_item_top"><i class="iconfont icon-lidianchi"></i>
                    <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.energy.EnergyStorage')" placement="top-start">
                        <span>{{ $t('ems.energy.EnergyStorage') }}</span>
                    </el-tooltip>
                    </div> 
                    <div class="arrow"></div>

                </div>
                <div :class="{tab_item: true,  active: active === 3}"  @click="tabChange(3)" v-if="systemMenu.BKKFZ">
                    <div class="tab_item_top"><i class="iconfont icon-deng" style="font-size: 30px"></i>
                    <el-tooltip :open-delay="1500" :disabled="language === 'zh'" effect="dark" :content="$t('ems.energy.load')" placement="top-start">
                        <span>{{ $t('ems.energy.load') }}</span>
                    </el-tooltip>
                    </div>
                    <div class="arrow"></div>
                </div>
            </div>
            <div class="boxGroup" v-if="active === 0">
                <div class="boxItem">
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.DailyDischarge1') }}</div>
                        <div class="item_value">{{currentData.todayCharge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.CurrentCharge1') }}</div>
                        <div class="item_value">{{currentData.todayDischarge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.DailyEarnings')}}{{uint}}</div>
                        <div class="item_value">{{currentData.todayFee | numberFormat2}}</div>
                    </div>
                </div>
                <div class="boxItem">
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.DischargeElectricityCurrentMonth1') }}</div>
                        <div class="item_value">{{currentData.monthCharge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.CurrentMonthCharge1') }}</div>
                        <div class="item_value">{{currentData.monthDischarge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.CurrentMonthEarnings') }}{{uint}}</div>
                        <div class="item_value">{{currentData.monthFee | numberFormat2}}</div>
                    </div>
                </div>
                <div class="boxItem">
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.DischargeElectricityCurrentYear1') }}</div>
                        <div class="item_value">{{currentData.yearCharge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.CurrentYearCharge1') }}</div>
                        <div class="item_value">{{currentData.yearDischarge| numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.CurrentYearIncome') }}{{uint}}</div>
                        <div class="item_value">{{currentData.yearFee | numberFormat2}}</div>
                    </div>
                </div>
            </div>
            <div class="boxGroup" v-if="active === 1">
                <div class="boxItem">
                    <div class="item">
                        <div class="item_title">{{ $t('ems.pv.DailyPowerGeneration') }}</div>
                        <div class="item_value">{{currentData.todayCharge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.DailyEarnings1') }}{{uint}}</div>
                        <div class="item_value">{{currentData.todayFee | numberFormat2}}</div>
                    </div>
                </div>
                <div class="boxItem">
                    <div class="item">
                        <div class="item_title">{{ $t('ems.pv.MonthPowerGeneration')  }}</div>
                        <div class="item_value">{{currentData.monthCharge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.CurrentMonthEarnings1') }}{{uint}}</div>
                        <div class="item_value">{{currentData.monthFee | numberFormat2}}</div>
                    </div>
                </div>
                <div class="boxItem">
                    <div class="item">
                        <div class="item_title">{{ $t('ems.pv.YearPowerGeneration')  }}</div>
                        <div class="item_value">{{currentData.yearCharge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.CurrentYearIncome1') }}{{uint}}</div>
                        <div class="item_value">{{currentData.yearFee | numberFormat2}}</div>
                    </div>
                </div>
            </div>
            <div class="boxGroup" v-if="active === 2">
                <div class="boxItem">
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.DailyDischarge') }}</div>
                        <div class="item_value">{{currentData.todayDischarge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.CurrentCharge') }}</div>
                        <div class="item_value">{{currentData.todayCharge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.DailyEarnings1') }}{{uint}}</div>
                        <div class="item_value">{{currentData.todayProfit | numberFormat2}}</div>
                    </div>
                </div>
                <div class="boxItem">
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.DischargeElectricityCurrentMonth') }}</div>
                        <div class="item_value">{{currentData.monthDischarge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.CurrentMonthCharge') }}</div>
                        <div class="item_value">{{currentData.monthCharge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.CurrentMonthEarnings1') }}{{uint}}</div>
                        <div class="item_value">{{currentData.monthProfit | numberFormat2}}</div>
                    </div>
                </div>
                <div class="boxItem">
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.DischargeElectricityCurrentYear') }}</div>
                        <div class="item_value">{{currentData.yearDischarge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.CurrentYearCharge') }}</div>
                        <div class="item_value">{{currentData.yearCharge | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.CurrentYearIncome1') }}{{uint}}</div>
                        <div class="item_value">{{currentData.yearProfit | numberFormat2}}</div>
                    </div>
                </div>
            </div>
            <div class="boxGroup" v-if="active === 3">
                <div class="boxItem">
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.DailyPowerCost') }}</div>
                        <div class="item_value">{{currentData.todayDischarge  | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.DailyPowerEarnings') }}{{uint}}</div>
                        <div class="item_value">{{currentData.todayFee  | numberFormat2}}</div>
                    </div>
                </div>
                <div class="boxItem">
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.MonthPowerCost') }}</div>
                        <div class="item_value">{{currentData.monthDischarge  | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.MonthPowerEarnings') }}{{uint}}</div>
                        <div class="item_value">{{currentData.monthFee  | numberFormat2}}</div>
                    </div>
                </div>
                <div class="boxItem">
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.YearPowerCost') }}</div>
                        <div class="item_value">{{currentData.yearDischarge  | numberFormat0}}</div>
                    </div>
                    <div class="item">
                        <div class="item_title">{{ $t('ems.energy.YearPowerEarnings') }}{{uint}}</div>
                        <div class="item_value">{{currentData.yearFee  | numberFormat2}}</div>
                    </div>
                </div>
            </div>
            <div class="energy_chart">
                <div class="topContent">
                    <div class="leftbox">
                        <div :class="{item: true, item_active: form.active === 0}" @click="renderChartType(0, true)">
                            <span>{{ $t('ems.energy.daily') }}</span> 
                        </div>
                        <div :class="{item: true, item_active: form.active === 2}" @click="renderChartType(2, true)">
                            <span>{{ $t('ems.energy.month') }}</span>
                        </div>
                        <div :class="{item: true, item_active: form.active === 3}" @click="renderChartType(3, true)">
                            <span>{{ $t('ems.energy.year') }}</span>
                        </div>
                    </div>
                    <div class="rightbox">
                        <el-form
                                class="table_header tableSearchForm"
                                :inline="true"
                                size="small"
                                label-width="80px"
                                label-position="left"
                        >
                            <el-form-item style="width: 400px">
                                <el-date-picker
                                        v-model="form.time"
                                        :type="dateType"
                                        :key="dateType"
                                        :range-separator="$t('ems.energy.to')"
                                        :start-placeholder="$t('ems.energy.StartDate')"
                                        :end-placeholder="$t('ems.energy.EndDate')"
                                        style="width: 100%"
                                        popper-class="dateDown"
                                >
                                </el-date-picker>
                            </el-form-item>
                            <div class="btn btn_active" @click="search">
                                <i class="iconfont icon-sousuo"></i><span>{{ $t('ems.energy.search') }}</span>
                            </div>
                            <div class="btn btn_active" @click="downLoad">
                                <i class="el-icon-download"></i><span>{{ $t('index.export') }}</span>
                            </div>
                        </el-form>
                    </div>
                </div>
                <div class="echartBox" ref="energyChart"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import { getGridEnergyCurrent, getGFEnergyDetail, getGFEnergyCurrent, getGridEnergyDetail, getLoadEnergyCurrent, getLoadEnergyDetail, getCnEnergyCurrent, getCnEnergyDetail, exportGridEnergyDetail, exportCnEnergyDetail, exportLoadEnergyDetail, exportBmsPvEnergyDetail } from "@/api/spms";
    import { setStore, getStore } from "@/utils/store";
    import { exportFile } from "@/utils/util";
import { mapGetters } from "vuex";
   import i18n from "@/lang";
    import moment from "moment";
    export default {
        name: "energySys",
        data(){
            return {
                loading: false,
                groupNo: getStore({name: "siteNo"})||"",
                active: 0,
                energyChart: null,
                currentData: {},
                dateType: 'daterange',
                form: {
                    time: [moment().subtract(7, 'd'), moment()],
                    active: 0
                },
                timer: null,
                uint: 'RMB',
            }
        },
        computed: {
            ...mapGetters(["language", "systemMenu", "systemSet"]),
        },
        created(){
            if(this.systemMenu.SD){ this.active = 0; return}
            if(this.systemMenu.GF){ this.active = 1; return}
            if(this.systemMenu.CN){ this.active = 2; return}
            if(this.systemMenu.BKKFZ){ this.active = 3; return}
        },
        filters: {
            nullFormat(val){
                if(val === null || val === undefined){
                    return "--"
                }else {
                    return val
                }
            },
        },
        mounted(){
            // this.renderChart();
            this.initData();
            this.renderChartType(0, true);
            this.uint = (this.systemSet.currencyUnit == null || this.systemSet.currencyUnit == undefined) ? '(RMB)' : '(' + this.systemSet.currencyUnit + ')';
            // if(this.systemSet && this.systemSet.isRealCalcProfit){
            //     const time = +this.systemSet.isRealCalcProfit;
            //     if(time > 0){
            //         this.timer = setInterval(() => {
            //             this.initData();
            //             this.renderChartType(this.form.active, false);
            //         }, 1000 * time)
            //     }
            // }
            this.timer = setInterval(() => {
                this.initData();
                this.renderChartType(this.form.active, false);
            }, 1000*30)
        },
        methods: {
            fresh(){
                this.loading = true;
                setTimeout( () => {
                    this.loading = false;
                    this.renderChartType(this.form.active, false);
                }, 1000);
            },
            tabChange(index){
                this.active = index;
                this.initData();
                this.renderChartType(0, true);
            },
            initData(){
                if(!this.$refs.energyChart) return;
                if(this.active === 0){
                    getGridEnergyCurrent(this.groupNo).then(res  => {
                        this.currentData = res.data.data;
                    }).catch(err => {
                        this.$message.error(err);
                        console.log(err);
                    });
                }else if(this.active === 1){
                    getGFEnergyCurrent(this.groupNo).then(res  => {
                        this.currentData = res.data.data;
                    }).catch(err => {
                        this.$message.error(err);
                        console.log(err);
                    });
                }else if(this.active === 2){
                    getCnEnergyCurrent(this.groupNo).then(res  => {
                        this.currentData = res.data.data;
                    }).catch(err => {
                        this.$message.error(err);
                        console.log(err);
                    });
                }else if(this.active === 3){
                    getLoadEnergyCurrent(this.groupNo).then(res  => {
                        this.currentData = res.data.data;
                    }).catch(err => {
                        this.$message.error(err);
                        console.log(err);
                    });
                }
            },
            loadChart(params){
                getGridEnergyDetail(params).then(res => {

                    if(!this.energyChart && this.$refs.energyChart){
                        this.energyChart = this.$echarts.init(this.$refs.energyChart);
                    }
                    
                    const data = res.data.data;
                    const color = this.$themeOption.title;
                    let ser1 = i18n.t("ems.energy.charge");
                    const option = {
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid: {
                            top: '20%',
                            left: '5%',
                            right: '5%',
                            bottom: '3%',
                            containLabel: true
                        },
                        legend: {
                            data: [i18n.t("ems.energy.charge"), i18n.t("ems.chart.cnJdUncharge"), i18n.t("ems.energy.PeakDischarge"), i18n.t("ems.energy.FlatDischarge"), i18n.t("ems.energy.PeakValleyDischarge"),  i18n.t("ems.energy.SharpBills"), i18n.t("ems.energy.PeakBills"), i18n.t("ems.energy.FlatBills"), i18n.t("ems.energy.PeakValleyBill"),],
                            icon: 'rect',
                            itemWidth: 20,  // 设置宽度
                            itemHeight: 12, // 设置高度
                            itemGap: 20,
                            textStyle: {
                                color,
                                fontSize: 16,
                            },
                            top: '5%',
                            selected: {
                                [""+ser1]: false,
                            }
                        },
                        color: ['rgba(255,179,54,0.78)', 'rgb(255,0,45)', 'rgba(255,68,105,0.73)', 'rgba(104,99,234,0.71)', '#79ebd4', 'rgb(255,0,45)', '#ff0ea4', '#4d46ea', '#24eb70'],
                        xAxis: [
                            {
                                type: 'category',
                                data: data.map(i => i.statisTime ),
                                axisPointer: {
                                    type: 'shadow'
                                },
                                axisLine: {
                                    lineStyle: {
                                        color,
                                    }
                                },
                                // axisTick: {
                                //     alignWithLabel: true
                                // },
                                splitLine: {
                                    show: true,
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                        }
                                },
                                // boundaryGap: false,
                            }
                        ],
                        yAxis: [
                            {
                                name: i18n.t("ems.energy.Power"),
                                nameTextStyle: {
                                    fontSize: 16,
                                    width: 20,
                                    overflow: 'break',
                                    padding: [0, 0, 10, 0],
                                    lineHeight: 20,
                                },
                                type: 'value',
                                axisLabel: {
                                    formatter: '{value}',
                                    color:  this.$themeOption.labelY,
                                },
                                axisLine: {
                                    lineStyle: {
                                        color:  this.$themeOption.labelY,
                                    }
                                },
                                splitLine: {
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                            // dashOffset: 10
                                        }
                                }
                            },
                            {
                                name: i18n.t("ems.energy.Cost") + this.uint,
                                nameTextStyle: {
                                    fontSize: 16,
                                    width: 10,
                                    overflow: 'break',
                                    padding: [0, 0, 10, 0],
                                    lineHeight: 20,
                                },
                                axisLabel: {
                                    formatter: '{value}',
                                    color:  this.$themeOption.labelY,
                                },
                                axisLine: {
                                    lineStyle: {
                                        color:  this.$themeOption.labelY,
                                    }
                                },
                                splitLine: {
                                    show: false,
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                            // dashOffset: 10
                                        }
                                }
                            }
                        ],
                        series: [
                            {
                                name: i18n.t("ems.energy.charge"),
                                type: 'bar',
                                emphasis: {
                                    focus: 'series'
                                },
                                barMaxWidth: 30,
                                data: data.map(i => +i.disCharge  ),
                            },
                            {
                                name: i18n.t("ems.chart.cnJdUncharge"),
                                type: 'bar',
                                emphasis: {
                                    focus: 'series'
                                },
                                stack: 'Ad',
                                barMaxWidth: 30,
                                data: data.map(i => +i.jdCharge ),
                            },
                            {
                                name: i18n.t("ems.energy.PeakDischarge"),
                                type: 'bar',
                                stack: 'Ad',
                                emphasis: {
                                    focus: 'series'
                                },
                                barMaxWidth: 30,
                                data: data.map(i => +i.fdCharge  ),
                            },
                            {
                                name:  i18n.t("ems.energy.FlatDischarge"),
                                type: 'bar',
                                stack: 'Ad',
                                barMaxWidth: 30,
                                emphasis: {
                                    focus: 'series'
                                },
                                data: data.map(i => +i.pdCharge  ),
                            },
                            {
                                name:i18n.t("ems.energy.PeakValleyDischarge"),
                                type: 'bar',
                                stack: 'Ad',
                                barMaxWidth: 30,
                                emphasis: {
                                    focus: 'series'
                                },
                                data: data.map(i => +i.gdCharge  ),
                            },
                            {
                                name: i18n.t("ems.energy.SharpBills"),
                                type: 'line',
                                smooth: true,
                                data: data.map(i => +i.jdFee)  ,
                                yAxisIndex: 1,
                            },
                            {
                                name: i18n.t("ems.energy.PeakBills"),
                                type: 'line',
                                smooth: true,
                                data: data.map(i => +i.fdFee)  ,
                                yAxisIndex: 1,
                            },
                            {
                                name: i18n.t("ems.energy.FlatBills"),
                                type: 'line',
                                smooth: true,
                                data: data.map(i => +i.pdFee),
                                yAxisIndex: 1,
                            },
                            {
                                name: i18n.t("ems.energy.PeakValleyBill"),
                                type: 'line',
                                smooth: true,
                                data:  data.map(i => +i.gdFee),
                                yAxisIndex: 1,
                            },
                        ]
                    };
                    this.energyChart.setOption(option, true);
                }).catch(err =>{
                    // this.$message.error(err);
                    console.log(err)
                });
            },
            loadChart1(params){
                getGFEnergyDetail(params).then(res => {

                    if(!this.energyChart && this.$refs.energyChart){
                        this.energyChart = this.$echarts.init(this.$refs.energyChart);
                    }

                    const data = res.data.data;
                    const color = this.$themeOption.title;
                    const option = {
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid: {
                            top: '20%',
                            left: '5%',
                            right: '5%',
                            bottom: '3%',
                            containLabel: true
                        },
                        legend: {
                            data: [i18n.t("ems.energy.dischargeCapacity"), i18n.t("ems.earnings")],
                            icon: 'rect',
                            itemWidth: 20,  // 设置宽度
                            itemHeight: 12, // 设置高度
                            itemGap: 20,
                            textStyle: {
                                color,
                                fontSize: 16,
                            },
                            top: '5%',
                        },
                        color: ['rgba(255,179,54,0.78)', 'rgb(255,0,45)', 'rgba(255,68,105,0.73)', 'rgba(104,99,234,0.71)', '#79ebd4', 'rgb(255,0,45)', '#ff0ea4', '#4d46ea', '#24eb70'],
                        xAxis: [
                            {
                                type: 'category',
                                data: data.map(i => i.statisTime ),
                                axisPointer: {
                                    type: 'shadow'
                                },
                                axisLine: {
                                    lineStyle: {
                                        color,
                                    }
                                },
                                // axisTick: {
                                //     alignWithLabel: true
                                // },
                                splitLine: {
                                    show: true,
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                        }
                                },
                                // boundaryGap: false,
                            }
                        ],
                        yAxis: [
                            {
                                name: i18n.t("ems.energy.Power"),
                                nameTextStyle: {
                                    fontSize: 16,
                                    width: 20,
                                    overflow: 'break',
                                    padding: [0, 0, 10, 0],
                                    lineHeight: 20,
                                },
                                type: 'value',
                                axisLabel: {
                                    formatter: '{value}',
                                    color:  this.$themeOption.labelY,
                                },
                                axisLine: {
                                    lineStyle: {
                                        color:  this.$themeOption.labelY,
                                    }
                                },
                                splitLine: {
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                            // dashOffset: 10
                                        }
                                }
                            },
                            {
                                name: i18n.t("ems.energy.Cost") + this.uint,
                                nameTextStyle: {
                                    fontSize: 16,
                                    width: 10,
                                    overflow: 'break',
                                    padding: [0, 0, 10, 0],
                                    lineHeight: 20,
                                },
                                axisLabel: {
                                    formatter: '{value}',
                                    color:  this.$themeOption.labelY,
                                },
                                axisLine: {
                                    lineStyle: {
                                        color:  this.$themeOption.labelY,
                                    }
                                },
                                splitLine: {
                                    show: false,
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                            // dashOffset: 10
                                        }
                                }
                            }
                        ],
                        series: [
                            {
                                name: i18n.t("ems.energy.dischargeCapacity"),
                                type: 'bar',
                                emphasis: {
                                    focus: 'series'
                                },
                                barMaxWidth: 30,
                                data: data.map(i => +i.discharge  ),
                            },
                            {
                                name: i18n.t("ems.earnings"),
                                type: 'line',
                                smooth: true,
                                data: data.map(i => +i.fee)  ,
                                yAxisIndex: 1,
                            },
                        ]
                    };
                    this.energyChart.setOption(option, true);
                }).catch(err =>{
                    // this.$message.error(err);
                    console.log(err)
                });
            },

            loadChart3(params){
                getLoadEnergyDetail(params).then(res => {

                    if(!this.energyChart && this.$refs.energyChart){
                        this.energyChart = this.$echarts.init(this.$refs.energyChart);
                    }
                    
                    const data = res.data.data;
                    const color = this.$themeOption.title;
                    const option = {
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid: {
                            top: '20%',
                            left: '5%',
                            right: '5%',
                            bottom: '3%',
                            containLabel: true
                        },
                        legend: {
                            data: [i18n.t("ems.energy.Power"), i18n.t("ems.energy.Cost")],
                            icon: 'rect',
                            itemWidth: 20,  // 设置宽度
                            itemHeight: 12, // 设置高度
                            itemGap: 20,
                            textStyle: {
                                color,
                                fontSize: 16,
                            },
                            top: '5%',
                        },
                        color: ['#ffb336', '#ff4469', '#6863ea', '#79ebd4', '#ff0ea4', '#4d46ea', '#24eb70'],
                        xAxis: [
                            {
                                type: 'category',
                                data: data.map(i => i.statisTime ),
                                axisPointer: {
                                    type: 'shadow'
                                },
                                axisLine: {
                                    lineStyle: {
                                        color:  this.$themeOption.labelY,
                                    }
                                },
                                // axisTick: {
                                //     alignWithLabel: true
                                // },
                                splitLine: {
                                    show: true,
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                        }
                                },
                                // boundaryGap: false,
                            }
                        ],
                        yAxis: [
                            {
                                name: i18n.t("ems.energy.Power"),
                                nameTextStyle: {
                                    fontSize: 16,
                                    width: 20,
                                    overflow: 'break',
                                    padding: [0, 0, 10, 0],
                                    lineHeight: 20,
                                },
                                type: 'value',
                                axisLabel: {
                                    formatter: '{value}',
                                    color:  this.$themeOption.labelY,
                                },
                                axisLine: {
                                    lineStyle: {
                                        color:  this.$themeOption.labelY,
                                    }
                                },
                                splitLine: {
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                            // dashOffset: 10
                                        }
                                }
                            },
                            {
                                name: i18n.t("ems.energy.Cost") + this.uint,
                                nameTextStyle: {
                                    fontSize: 16,
                                    width: 10,
                                    overflow: 'break',
                                    padding: [0, 0, 10, 0],
                                    lineHeight: 20,
                                },
                                axisLabel: {
                                    formatter: '{value}',
                                    color:  this.$themeOption.labelY,
                                },
                                axisLine: {
                                    lineStyle: {
                                        color:  this.$themeOption.labelY,
                                    }
                                },
                                splitLine: {
                                    show: false,
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                            // dashOffset: 10
                                        }
                                }
                            }
                        ],
                        series: [
                            {
                                name: i18n.t("ems.energy.Power"),
                                type: 'bar',
                                emphasis: {
                                    focus: 'series'
                                },
                                barMaxWidth: 30,
                                data: data.map(i => +i.charge  ),
                            },
                            {
                                name: i18n.t("ems.energy.Cost") + this.uint,
                                type: 'line',
                                smooth: true,
                                data:  data.map(i => +i.fee),
                                yAxisIndex: 1,
                            },
                        ]
                    };
                    this.energyChart.setOption(option, true);
                }).catch(err =>{
                    // this.$message.error(err);
                    console.log(err)
                });
            },
            loadChart2(params){
                getCnEnergyDetail(params).then(res => {

                    if(!this.energyChart && this.$refs.energyChart){
                        this.energyChart = this.$echarts.init(this.$refs.energyChart);
                    }
                    
                    const data = res.data.data;
                    const color = this.$themeOption.title;
                    const option = {
                        tooltip: {
                            trigger: 'axis',
                            axisPointer: {
                                type: 'shadow'
                            }
                        },
                        grid: {
                            top: '20%',
                            left: '5%',
                            right: '5%',
                            bottom: '3%',
                            containLabel: true
                        },
                        legend: {
                            data: [i18n.t('ems.energy.dischargeCapacity'),  i18n.t('ems.energy.charge'),  i18n.t('ems.energy.earnings')],
                            icon: 'rect',
                            itemWidth: 20,  // 设置宽度
                            itemHeight: 12, // 设置高度
                            itemGap: 20,
                            textStyle: {
                                color,
                                fontSize: 16,
                            },
                            top: '5%',
                        },
                        color: ['#ffb336', '#ff4469', '#6863ea', '#79ebd4', '#ff0ea4', '#4d46ea', '#24eb70'],
                        xAxis: [
                            {
                                type: 'category',
                                data: data.map(i => i.statisTime ),
                                axisPointer: {
                                    type: 'shadow'
                                },
                                axisLine: {
                                    lineStyle: {
                                        color:  this.$themeOption.labelY,
                                    }
                                },
                                // axisTick: {
                                //     alignWithLabel: true
                                // },
                                splitLine: {
                                    show: true,
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                        }
                                },
                                // boundaryGap: false,
                            }
                        ],
                        yAxis: [
                            {
                                name: i18n.t("ems.energy.Power"),
                                nameTextStyle: {
                                    fontSize: 16,
                                    width: 20,
                                    overflow: 'break',
                                    padding: [0, 0, 10, 0],
                                    lineHeight: 20,
                                },
                                type: 'value',
                                axisLabel: {
                                    formatter: '{value}',
                                    color:  this.$themeOption.labelY,
                                },
                                axisLine: {
                                    lineStyle: {
                                        color:  this.$themeOption.labelY,
                                    }
                                },
                                splitLine: {
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                            // dashOffset: 10
                                        }
                                }
                            },
                            {
                                name: i18n.t("ems.energy.Cost"),
                                nameTextStyle: {
                                    fontSize: 16,
                                    width: 10,
                                    overflow: 'break',
                                    padding: [0, 0, 10, 0],
                                    lineHeight: 20,
                                },
                                axisLabel: {
                                    formatter: '{value}',
                                    color:  this.$themeOption.labelY,
                                },
                                axisLine: {
                                    lineStyle: {
                                        color,
                                    }
                                },
                                splitLine: {
                                    show: false,
                                    lineStyle:
                                        {
                                            type: 'dashed',
                                            color: 'rgb(89, 89, 89)'
                                            // dashOffset: 10
                                        }
                                }
                            }
                        ],
                        series: [
                            {
                                name: i18n.t('ems.energy.dischargeCapacity'),
                                type: 'bar',
                                emphasis: {
                                    focus: 'series'
                                },
                                barMaxWidth: 30,
                                data: data.map(i => +i.charge  ),
                            },
                            {
                                name:  i18n.t('ems.energy.charge'),
                                type: 'bar',
                                emphasis: {
                                    focus: 'series'
                                },
                                barMaxWidth: 30,
                                data: data.map(i => +i.discharge  ),
                            },
                            {
                                name: i18n.t('ems.energy.earnings'),
                                type: 'line',
                                smooth: true,
                                data:  data.map(i => +i.profit),
                                yAxisIndex: 1,
                            },
                        ]
                    };
                    this.energyChart.setOption(option, true);
                }).catch(err =>{
                    // this.$message.error(err);
                    console.log(err)
                });
            },
            renderChartType(index,isInit){
                this.form.active = index;
                const params ={};
                params.groupNo = this.groupNo;
                params.type = index;
                if(index === 0) {
                    if(isInit) this.form.time =  [moment().subtract(7, 'd'), moment()];
                    this.dateType = "daterange";
                    params.startTime = moment(this.form.time[0]).startOf('day').format("YYYY-MM-DD HH:mm:ss");
                    params.endTime = moment(this.form.time[1]).endOf('day').format("YYYY-MM-DD HH:mm:ss");
                }
                if (index === 2) {
                    if(isInit) this.form.time =  [moment().subtract(3, 'M'), moment()];
                    this.dateType = "monthrange";
                    params.startTime = moment(this.form.time[0]).startOf('month').format("YYYY-MM-DD HH:mm:ss");
                    params.endTime = moment(this.form.time[1]).endOf('month').format("YYYY-MM-DD HH:mm:ss");
                }
                if (index === 3) {
                    if(isInit) this.form.time =  [moment().subtract(5, 'y'), moment()];
                    this.dateType = "monthrange";
                    params.startTime = moment(this.form.time[0]).startOf('year').format("YYYY-MM-DD HH:mm:ss");
                    params.endTime = moment(this.form.time[1]).endOf('year').format("YYYY-MM-DD HH:mm:ss");
                }
                if(this.active === 0) this.loadChart(params);
                if(this.active === 1) this.loadChart1(params);
                if(this.active === 2) this.loadChart2(params);
                if(this.active === 3) this.loadChart3(params);
            },
            search(){
                this.renderChartType(this.form.active, false);
            },
            downLoad(){
                const index = this.active;
                const params ={};
                params.groupNo = this.groupNo;
                params.type = this.form.active;
                if( this.form.active === 0) {
                    params.startTime = moment(this.form.time[0]).startOf('day').format("YYYY-MM-DD HH:mm:ss");
                    params.endTime = moment(this.form.time[1]).endOf('day').format("YYYY-MM-DD HH:mm:ss");
                }
                if ( this.form.active === 2) {
                    params.startTime = moment(this.form.time[0]).startOf('month').format("YYYY-MM-DD HH:mm:ss");
                    params.endTime = moment(this.form.time[1]).endOf('month').format("YYYY-MM-DD HH:mm:ss");
                }
                if ( this.form.active === 3) {
                    params.startTime = moment(this.form.time[0]).startOf('year').format("YYYY-MM-DD HH:mm:ss");
                    params.endTime = moment(this.form.time[1]).endOf('year').format("YYYY-MM-DD HH:mm:ss");
                }
                if (this.active === 0) {
                    exportGridEnergyDetail(params).then(res => {
                        this.$message.success("downloading");
                        exportFile(res.data, "excel");
                    })
                }
                if (this.active === 1) {
                    exportBmsPvEnergyDetail(params).then(res => {
                        this.$message.success("downloading");
                        exportFile(res.data, "excel");
                    })
                }
                if (this.active === 2) {
                    exportCnEnergyDetail(params).then(res => {
                        this.$message.success("downloading");
                        exportFile(res.data, "excel");
                    })
                }
                if (this.active === 3) {
                    exportLoadEnergyDetail(params).then(res => {
                        this.$message.success("downloading");
                        exportFile(res.data, "excel");
                    })
                }
            }
        },
        destroyed() {
            if(this.timer) clearInterval(this.timer);
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../../styles/site";
    .win{
        transition: all 0.5s linear;
        width: 100%;
        height: 100%;
        .header{
            height: 52px;
            background-color: var(--nav_inner);
            position: relative;
            .navItem{
                height: 100%;
                color: $font_bright_blue_title;
                display: flex;
                align-items: center;
                transition: all 0.3s linear;
                i{
                    font-size: 22px;
                    margin: 3px 20px 0;
                }
                .title{
                    letter-spacing: 3px;
                    font-size: 22px;
                }
                .desc{
                    margin-left: 24px;
                    font-size: 16px;
                    color: $_128_128_128;
                }
            }
            .navRight{
                position: absolute;
                height: 100%;
                right: 0;
                top: 0;
                display: flex;
                align-items: center;
                .creatTime{
                    font-size: 18px;
                    color: $_191_191_191;
                    margin-right: 40px;
                    span{
                        padding-left: 20px;
                        color: $font_bright_blue_title
                    }
                }
                .btn{
                    height: 30px;
                    width: 85px;
                    border: $font_bright_blue_title solid 2px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 14px;
                    color: $font_bright_blue_title;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                    i{
                        margin-right: 5px;
                        font-size: 18px;
                    }
                }
            }
        }
        .content{
            height: calc(100% -  52px);
            padding: 0 30px;
            overflow: hidden;
            .pcs_tab{
                height: 80px;
                border-bottom: $font_bright_blue solid 1px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 160px;
                position: relative;
                .tab_item{
                    width: 150px;
                    height: 50px;
                    border: $_128_128_128 solid 1px;
                    text-align: center;
                    cursor: pointer;
                    -webkit-tap-highlight-color:rgba(0,0,0,0);
                    position: relative;
                    color: $_191_191_191;
                    transition: all 300ms linear;
                    .tab_item_top{
                        height: 50px;
                        line-height: 50px;
                        font-size: 24px;
                        width: 150px;
                        box-sizing: border-box;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        white-space:nowrap;
                        i{
                            font-size: 24px;
                            padding-right: 16px;
                        }
                    }

                    .arrow{
                        border-top-width: 0;
                        border-width: 8px;
                        width: 0;
                        height: 0;
                        border-color: transparent;
                        border-bottom-color: transparent;
                        border-style: solid;
                        position: absolute;
                        left: 67px;
                        bottom: -15px;
                    }
                }
                .active{
                    border: $font_bright_blue_title solid 1px;
                    color: $font_bright_blue_title;
                    .arrow{
                        border-bottom-color: $font_bright_blue_title;
                    }
                }

            }
            .boxGroup{
                margin: 20px 0;
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                .boxItem{
                    width: 460px;
                    height: 120px;
                    background-color: var(--nav_inner);
                    border: 1px solid $_89_89_89;
                    display: flex;
                    justify-content: center;
                    flex-direction: row;
                    .item{
                        flex: 1;
                        border-right: 1px solid $_89_89_89;
                        margin: 14px 0 ;
                        text-align: center;
                        .item_title{
                            color: $_191_191_191;
                            font-size: 14px;
                            margin-top: 5px;
                            padding: 0 5px;
                            letter-spacing: 1px;
                        }
                        .item_value{
                            color: $font_bright_blue;
                            font-size: 28px;
                            margin-top: 20px;
                        }
                    }
                    .item:last-child{
                        border: none;
                    }
                }
            }
            .energy_chart{
                width: 100%;
                background-color: var(--bg38);
                border: 1px solid $_89_89_89;
                height: 570px;
                .topContent {
                    height: 60px;
                    border-bottom: 1px dashed $_191_191_191;
                    position: relative;
                    .leftbox {
                        display: flex;
                        position: absolute;
                        top: 16px;
                        left: 20px;
                        .item {
                            width: 68px;
                            height: 28px;
                            color: $_191_191_191;
                            border: 1px solid $_191_191_191;
                            text-align: center;
                            line-height: 30px;
                            margin-right: 15px;
                            font-size: 14px;
                            cursor: pointer;
                            -webkit-tap-highlight-color:rgba(0,0,0,0);
                            transition: all 300ms linear;
                        }
                        .item_active{
                            border: $font_bright_blue_title solid 1px;
                            color: $font_bright_blue_title;
                        }
                    }
                    .rightbox {
                        position: absolute;
                        top: 16px;
                        right: 20px;
                        .btn {
                            display: inline-block;
                            height: 28px;
                            width: 80px;
                            color: $_191_191_191;
                            border: $_191_191_191 solid 2px;
                            margin-right: 20px;
                            font-size: 15px;
                            cursor: pointer;
                            -webkit-tap-highlight-color:rgba(0,0,0,0);
                            transition: all 300ms linear;
                            line-height: 26px;
                            text-align: center;
                            i {
                                margin-right: 5px;
                                font-size: 18px;
                            }
                            span {
                                margin-top: -2px;
                            }
                        }
                        .btn_active {
                            border: $font_bright_blue_title solid 2px;
                            color: $font_bright_blue_title;
                        }
                    }
                }
                .echartBox {
                    height: calc(100% - 75px);
                }
            }
        }
    }
</style>